var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmazon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25.4C0 28.9933 2.96 32 6.6 32H25.4067C29.0467 31.9933 32 29.04 32.0067 25.4V6.6C32.0067 3.00667 29.0467 0 25.4067 0H6.6C3 0 0 2.96 0 6.6V25.4067V25.4Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9396 15.9067V9.8067C21.9396 7.8667 20.1729 5.3667 16.5662 5.3667C12.9596 5.3667 11.1262 7.00003 10.3462 9.8067C10.3462 9.8067 12.6396 10.2934 13.7396 10.3667C14.1329 9.1867 14.5462 8.70003 15.9996 8.70003C18.1596 8.70003 18.2596 10.3667 18.2596 12.02C11.3329 12.3 9.21289 14.1734 9.21289 17.0134C9.21289 19.2334 11.7196 20.9 13.7396 20.9C15.7596 20.9 16.9196 20.5467 18.2662 19.2334C18.8996 20.2 20.5262 20.9 20.5262 20.9L22.7862 18.6734C22.7862 18.6734 21.9396 16.7667 21.9396 15.9V15.9067ZM15.4329 18.4067C14.6129 18.4067 13.7796 17.92 13.7329 16.1867C13.6929 14.7 16.2796 13.9734 18.2596 13.9734C18.3929 17.0934 16.5596 18.4134 15.4329 18.4134V18.4067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8329 26.9933C25.4729 26.9933 25.1596 26.7333 25.0929 26.3733C25.0196 26.02 25.2196 25.6666 25.5662 25.5333C26.0196 25.36 26.3929 24.12 26.5129 22.9133C25.5662 22.7533 24.0662 22.6867 23.4129 23.3267C23.1196 23.6133 22.6529 23.6066 22.3596 23.32C22.0729 23.0266 22.0596 22.56 22.3529 22.26C23.9262 20.6866 27.1329 21.4866 27.4996 21.58C27.8396 21.6666 28.0729 21.9733 28.0662 22.3267C28.0529 22.98 27.8796 26.2666 26.0996 26.9466C26.0129 26.9866 25.9262 27 25.8329 27V26.9933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1333 27.2334C10.6933 27.2334 7.2 25.8334 4.16 22.8334C3.86 22.5401 3.85334 22.0601 4.15334 21.7667C4.44667 21.4667 4.92 21.4667 5.21334 21.7601C8.01333 24.5267 11.12 24.9734 15.24 24.9734C18.6933 24.9601 21.7267 25.0001 24.4933 23.5534C24.8667 23.3534 25.3267 23.5067 25.5133 23.8734C25.7133 24.2401 25.56 24.7001 25.1933 24.8867C22.2067 26.4467 18.96 27.2201 15.2533 27.2334H15.1333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_775_583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazon);
export default __webpack_public_path__ + "static/media/Amazon.4063610036ba4a72a79a4f853c4969e0.svg";
export { ForwardRef as ReactComponent };